import { orchestrator } from 'satcheljs';
import { resetQuickCompose, closeComposeForm } from 'owa-calendar-compose-form-actions';
import { isEventAMeeting } from 'owa-calendar-event-capabilities';
import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { lazyOpenCalendarQuickCompose } from 'owa-calendar-compose-form-lifecycle';

orchestrator(resetQuickCompose, actionMessage => {
    closeComposeForm(
        actionMessage.formId,
        isEventAMeeting(getComposeEvent(actionMessage.formId)) /* isMeeting */,
        true /* shouldResetComposeStore */,
        true /* shouldClosePopOutWindow */,
        false /* shouldClearPreview */
    );

    lazyOpenCalendarQuickCompose.importAndExecute(
        actionMessage.anchor,
        actionMessage.entrySource,
        actionMessage.viewType,
        actionMessage.event
    );
});
